import { create } from 'zustand';
import { TemplateConfig, TemplateError } from '@brighterion/types/config';
import { getRuleSets, getTemplate, initLocaleService } from 'Services';

type Template = TemplateConfig & {
    ruleSets: RuleSets;
};

type TemplateState = {
    template: Partial<Template>;
    error?: TemplateError;
    clearTemplate: () => void;
    fetchTemplate: () => Promise<void>;
};

const defaultTemplate = {
    ruleSets: undefined,
    templateRepositoryId: undefined,
    currencyCode: undefined,
    locale: undefined,
    clientId: undefined
};

export const useTemplateStore = create<TemplateState>((set) => ({
    template: defaultTemplate,
    error: undefined,
    clearTemplate: () => set({ template: defaultTemplate }),
    fetchTemplate: async () => {
        const { data, error } = await getTemplate();
        initLocaleService(data?.locale ?? 'en', data?.currencyCode ?? 'USD');
        set({
            template: { ...data, ruleSets: await getRuleSets() },
            error
        });
    }
}));
